<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Property Report</ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="clearFilters()">
        Clear <ion-icon slot="end" name="backspace-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <form [formGroup]="filterForm">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Filter By</ion-label>
      </ion-list-header>

      <ion-item-divider>
        <ion-label>Sections</ion-label>
      </ion-item-divider>
      <div>
        <ion-item>
          <ion-checkbox formControlName="isDetailsAndCharacteristicsVisible"> Details & Characteristics </ion-checkbox>
        </ion-item>
        @if (showPlatMap$ | async ) {
        <ion-item>
          <ion-checkbox formControlName="isPlatMapVisible">Plat Map</ion-checkbox>
        </ion-item>
        } @if (showSaleInformation$ | async) {
        <ion-item>
          <ion-checkbox formControlName="isSaleInformationVisible">Sale Information</ion-checkbox>
        </ion-item>
        } @if (showSchools$ | async) {
        <ion-item>
          <ion-checkbox formControlName="isSchoolsVisible">Schools</ion-checkbox>
        </ion-item>
        } @if (showTransactionHistory$ | async) {
        <ion-item>
          <ion-checkbox formControlName="isTransactionHistoryVisible">Transaction History</ion-checkbox>
        </ion-item>
        }
      </div>
    </ion-list>
  </form>

  <ion-button
    [routerLink]="[defaultBackHref, 'profile', profileId, 'report', 'preview']"
    class="tw:mx-4 tw:my-6"
    expand="block"
  >
    Create
    <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
  </ion-button>
</red-page-content>
